import { Search } from "react-feather";
import styles from "./TabHeader.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getFavouriteDetailsHandler } from "@redux/Bookmark/bookmark.action";
import debounceFunc from "@utils/debounce";
import { loadingBookmarkData } from "@redux/Bookmark/bookmarksSlice";
import { useEffect, useState } from "react";
import { tradeLanesFilters } from "../../utils/constant";
import { SingleFilter } from "@components/templates/Filters/SingleFilters";
import { MulitpleFilter } from "@components/templates/Filters/MultipleFilters";

export const TabHeader = ({ setPayload, payload, setSearch, setCurrentPage }) => {
  const state = useSelector((state) => state.bookmarkDetails.bookmarkData);
  const dispatch = useDispatch();
  const [filtersData, setFiltersData] = useState({});

  useEffect(() => {
    if (state?.filter && Object.keys(state.filter)?.length) {
      let filterObj = {};
      Object.keys(state.filter).map((item) => {
        if (state.filter[item] && state.filter[item].length) {
          filterObj[item] = state.filter[item];
        }
      });
      setFiltersData(filterObj);
    }
  }, [state?.filter]);

  const onChangeHandler = (parentFilter, filter, clearType) => {
    const payloadClone = JSON.parse(JSON.stringify(payload));
    if (clearType === "clear") {
      payloadClone.filters[parentFilter] = [];
    } else if (clearType === "clearAll") {
      payloadClone.filters = { ...tradeLanesFilters };
    } else {
      let index = payloadClone.filters[parentFilter].findIndex((filterValue) => filterValue === filter);
      if (index > -1) {
        payloadClone.filters[parentFilter].splice(index, 1);
      } else {
        payloadClone.filters[parentFilter].push(filter);
      }
    }
    payloadClone.from = 0;
    setCurrentPage(1);
    dispatch(loadingBookmarkData());
    dispatch(getFavouriteDetailsHandler({ payload: payloadClone }));
    setPayload(payloadClone);
  };

  const debouncedAddressBook = debounceFunc((value) => {
    const payloadClone = JSON.parse(JSON.stringify(payload));
    payloadClone.company_name = value;
    dispatch(loadingBookmarkData());
    dispatch(getFavouriteDetailsHandler({ payload: payloadClone }));
    setPayload(payloadClone);
    setCurrentPage(1);
    setSearch(value);
  }, 500);

  const onSearchHandler = (value) => {
    debouncedAddressBook(value);
  };

  return (
    <div className="d-flex">
      <span className={styles.bookmarkSearchContainer}>
        <span className={styles.bookmarkSearchIconContainer}>
          <Search size={14} color="#101828" />
        </span>
        <input onChange={(e) => onSearchHandler(e.target.value)} className={styles.bookmarkSearch} placeholder={`Search by Trade Lanes`} />
      </span>
      <div className="ml-3">{filtersData && Object.keys(filtersData).length === 1 ? <SingleFilter isDisabled={state.loading} filterData={filtersData} onChangeHandler={onChangeHandler} payload={payload} /> : <MulitpleFilter isDisabled={state.loading} filterData={filtersData} onChangeHandler={onChangeHandler} payload={payload} />}</div>
    </div>
  );
};
